import { useMap } from 'react-leaflet';
import { useEffect, useState } from 'react';

export const useZoomToUser = (userLocation: { lat: number; lng: number } | null) => {
    const map = useMap();
    const [hasZoomed, setHasZoomed] = useState(false);

    useEffect(() => {
        if (userLocation && !hasZoomed) {
            map.flyTo([userLocation.lat, userLocation.lng], 16, { duration: 1.5 });
            setHasZoomed(true);
        }
    }, [userLocation, hasZoomed, map]);
};
